<div class="container-fluid p-3 p-sm-5 mt-4 mt-sm-0 h-100">
  <div class="p-2">
    Purchase History Based on Transaction
    <span class="font-weight-bold">
      {{ transactionId }}
    </span>
  </div>
  <div class="portlet-box bg-watusi shadow-sm mt-2 mb-2">
    <div class="portlet-body">
      Records show that on {{ blockedTransactionTimestamp }} you were denied the
      purchase of cold or allergy medications. Please see the transaction
      history below for further details.
    </div>
  </div>
  <div id="accordionFlat" class="card-accordions-flat">
    <div class="card border rounded border-secondary mb-2 shadow-md">
      <div class="card-header text-primary" id="flatheadingOne">
        <a class="collapse-title">
          <div class="container">
            <div class="row m-2 align-items-center text-decoration-none">
              <div class="col">Transaction ID</div>
              <div class="col">Transaction Date</div>
              <div class="col">Activity Type</div>
              <div class="d-none d-sm-block col-sm">Pharmacy</div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <app-search-result
      *ngFor="let result of results"
      [result]="result"
    ></app-search-result>
  </div>
  <div
    *ngIf="offenderBlockListRecords.length"
    class="pt-2 pb-2 pl-4 pr-4 font-weight-bold"
  >
    {{ getBlockListMessage(offenderBlockListRecords[0]) }}
    <!-- Button trigger modal -->
    <button
      type="button"
      class="btn btn-primary mt-4 mb-4 mr-4 float-right"
      data-toggle="modal"
      data-target="#contactHtmlModal"
    >
      More Information
    </button>
    <!-- Modal -->
    <div
      class="modal fade"
      id="contactHtmlModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="contactHtmlModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font600" id="contactHtmlModalLabel">
              {{ offenderBlockListRecords[0].stateDesc }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body font-weight-normal">
            {{ offenderBlockListRecords[0].contactHtml }}
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
